export enum EventType {
    Normal = 0,
    ShortTerm = 1,
    LongTerm = 2
}